import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observer } from 'mobx-react';
import React, { useMemo } from 'react';
import { Card, OverlayTrigger, Popover, Table } from 'react-bootstrap';
import LoadingOverlay from '../LoadingOverlay';

const PropertyGroupUsers = (props) => {
  const users = useMemo(
    () =>
      props.propertyGroupsUsers
        .filter((propertyGroupsUser, index, self) => {
          if (propertyGroupsUser.user_type !== 'fruition') return false;
          const foundUser =
            self.findIndex((u) => u.user_id === propertyGroupsUser.user_id) ===
            index;
          return foundUser;
        })
        .map((propertyGroupsUser) => {
          const user = props.users.find(
            (user) => user.id === propertyGroupsUser.user_id
          );
          return user;
        })
        .filter((user) => user),
    [props.propertyGroupsUsers, props.users]
  );

  return (
    <Card>
      <Card.Header
        style={{ height: '63px' }}
        className='d-flex align-items-center'
      >
        Property Groups Users
        <OverlayTrigger
          trigger='hover'
          overlay={
            <Popover>
              <Popover.Content>
                Listing of users that have access to this property through a
                property group.
              </Popover.Content>
            </Popover>
          }
        >
          <FontAwesomeIcon icon={faInfoCircle} className='ml-2' />
        </OverlayTrigger>
      </Card.Header>
      <Card.Body>
        <Table responsive>
          <thead>
            <tr>
              <th>Name</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => {
              return (
                <tr>
                  <td>{user.name}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
        {props.loading ? <LoadingOverlay /> : null}
      </Card.Body>
    </Card>
  );
};

export default observer(PropertyGroupUsers);
